import AddInactivityAlertModalForm from './AddInactivityAlertModalForm'

export default AddInactivityAlertModalForm
